import SVGComponent from 'types/SVGComponent';
import { ProductDocumentTypeId } from 'types/models/ProductDocumentType';
import DocumentPDFIcon from 'assets/icons/document-pdf.svg';
import DocumentSTPIcon from 'assets/icons/document-stp.svg';
import DocumentGLTFIcon from 'assets/icons/document-gltf.svg';

export const documentTypeIconsMap: Record<ProductDocumentTypeId, SVGComponent> = {
  PDF: DocumentPDFIcon,
  STP: DocumentSTPIcon,
  GLTF: DocumentGLTFIcon,
};
